import { RequestErrorResponse } from '@/utils/request';

export const mapBanks = (banks: string[] | RequestErrorResponse) => {
  if ('error' in banks) {
    return [
      {
        value: 'error',
        label: 'erro ao carregar bancos',
        category: 'bank',
      },
    ];
  }

  return banks.map((b) => {
    return {
      value: b,
      label: b,
      category: 'bank',
    };
  });
};

export const mapLoanTypes = (types: string[] | RequestErrorResponse) => {
  if ('error' in types) {
    return [
      {
        value: 'error',
        label: 'erro ao carregar tipos',
        category: 'loanType',
      },
    ];
  }

  return types.map((b) => {
    return {
      value: b,
      label: b,
      category: 'loanType',
    };
  });
};
